import { atom } from 'recoil';
import { IIdioma } from '../../commons/types/crm';


export const idiomasAtom = atom<IIdioma[]>({
  key: 'idiomas', 
  default: [] as IIdioma[],
}); 
